module.exports = __webpack_public_path__ + "img/00972696000118.1aeec3f1.png";